import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  catchError,
  ReplaySubject,
  switchMap,
  take,
  tap,
  throwError,
} from 'rxjs';
import { AuthService } from 'src/app/shared/services/utils/auth.service';
import {
  GEE_IMAGE_API_BASE_URL,
  URL_GEO_API,
  environment,
} from 'src/environments/environment.prod';

const hasSession$ = new ReplaySubject<void>(1);
let hasSession = false;

export const authHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.verifyAuthentication();

  if (token && environment.useBearerToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'ngrok-skip-browser-warning': 'true'
      }
    });
  }

  if (!authService.getIsAuthenticated()) {
    if (req.url.includes('/me')) {
      return next(req).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            hasSession = true;
            hasSession$.next();
          }
        }),
        catchError((err) => {
          if (err.status === 401) {
            authService.handleWithoutAuthentication();
          }
          return throwError(() => err);
        }),
      );
    }

    if (req.url.includes('/communities-filter')) {
      return hasSession$.pipe(
        take(1),
        switchMap(() => next(req)),
      );
    }
  }

  return next(req).pipe(
    catchError((err) => {
      console.log(err);
      if (err.status === 401 || err.status === 419) {
        authService.handleWithoutAuthentication();
      }
      return throwError(() => err);
    }),
  );
};
